import React from 'react';
import AuthorByline from '../../../components/Atoms/AuthorByline';
import parseHTML from '../../../utilities/parseHTML';
import sanitize from '../../../utilities/parseHTML/purify';
import { configuration } from '../../../components/Molecules/ByLine/Constants';
import AuthorTooltip from '../../../components/Molecules/AuthorTooltip/AuthorTooltip';
import { genSocialLinks } from '../author';

const bylineTransformer = (query) =>
{
    const toolArray = [];
    const authorNode = query?.post?.author?.node || false;
    const reviewer = query?.reviewer || false;

    if (authorNode) 
    {
        const { socialLinks = [] } = typeof authorNode?.cdmfields?.author === 'object' ? authorNode.cdmfields.author : {};
        const { description = false } = typeof authorNode?.cdmfields?.metadata === 'object' ? authorNode.cdmfields.metadata : {};
        const authorDisplayName = parseHTML(authorNode.cdmfields.author.displayName, ['learningCenter']).parsed;
        const authorImage = authorNode?.localAvatar?.childImageSharp?.gatsbyImageData || false;
        const authorProps = {
            authorImage,
            displayName: authorDisplayName,
            biography: parseHTML(description, ['learningCenter']).parsed,
            socialLinks: genSocialLinks(socialLinks),
            url: sanitize(authorNode?.uri),
        };

        toolArray.push(
            <AuthorByline
                prefix={configuration.prefixAuthor}
                url={sanitize(authorNode?.uri)}
                author={ authorDisplayName }
                key="AuthorByline"
                renderTooltip={(children) => <AuthorTooltip {...authorProps}>{children}</AuthorTooltip>}
            />
        )
    }

    if (reviewer) 
    {
        const reviewerDisplayName = parseHTML(reviewer.cdmfields.author.displayName, ['learningCenter']).parsed;
        const reviewerImage = reviewer?.localAvatar?.childImageSharp?.gatsbyImageData || false;
        const { socialLinks = [] } = typeof reviewer?.cdmfields?.author === 'object' ? reviewer.cdmfields.author : {};
        const { description = false } = typeof reviewer?.cdmfields?.metadata === 'object' ? reviewer.cdmfields.metadata : {};
        const reviewerProps = {
            authorImage: reviewerImage,
            displayName: reviewerDisplayName,
            biography: parseHTML(description, ['learningCenter']).parsed,
            socialLinks: genSocialLinks(socialLinks),
            url: sanitize(reviewer?.uri),
        };

        toolArray.push(
            <AuthorByline
                prefix={configuration.prefixReviewer}
                url={sanitize(reviewer?.uri)}
                author={ reviewerDisplayName }
                key="ReviewerByline"
                renderTooltip={(children) => <AuthorTooltip {...reviewerProps}>{children}</AuthorTooltip>}
            />
        )
    }

    return toolArray;
}

export default bylineTransformer;